import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { AuthProvider } from '@/auth/AuthProvider'
import App from './App'

// iOS Safari zooms in when a text field takes focus and does not zoom back
// out. The 16px input rule in responsive.ts is meant to prevent that, but it
// only applies below the mobile breakpoint, so it misses e.g. a phone in
// landscape. maximum-scale=1 stops the focus zoom on iOS; since iOS 10 Safari
// ignores it for pinch zoom, so users can still zoom by hand. Android would
// honour it and block pinch zoom, hence the iOS-only check (iPadOS reports as
// a Mac with touch).
const isIOS =
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
if (isIOS) {
  document
    .querySelector('meta[name="viewport"]')
    ?.setAttribute(
      'content',
      'width=device-width, initial-scale=1.0, maximum-scale=1.0, viewport-fit=cover',
    )
}

const root = document.getElementById('root')
if (!root) throw new Error('Root element #root not found')

createRoot(root).render(
  <StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>,
)
